class ResultsBanner extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.eventBus = window.theme.nosto.eventBus
  }

  connectedCallback () {
    super.connectedCallback()

    this.eventBus.subscribe(
      window.theme.results.events.STATE.SEARCH_TOTAL_UPDATED,
      this.handleSearchTotalUpdated.bind(this),
    )
  }

  handleSearchTotalUpdated (payload) {
    this.renderBanner(payload)
    this.updatePageTitle(payload)
  }

  renderBanner ({ total, activeTerm }) {
    let string = total === 1 ? this.format.single : this.format.plural

    string = string
      .replaceAll('[count]', total)
      .replaceAll('[query]', activeTerm)

    if (this.els.text?.exists) {
      this.els.text.element.innerHTML = string
    }
  }

  updatePageTitle ({ total, activeTerm }) {
    let string =
      total === 1
        ? window.theme.strings.templates.search.pageTitle.one
        : window.theme.strings.templates.search.pageTitle.other

    string = string
      .replaceAll('[count]', total)
      .replaceAll('[query]', activeTerm)

    const txt = document.createElement('textarea')
    txt.innerHTML = string
    string = txt.value

    document.title = string
  }

  get format () {
    return {
      single: this.dataset.formatSingle,
      plural: this.dataset.formatPlural,
    }
  }
}

if (!customElements.get('results-banner')) {
  customElements.define('results-banner', ResultsBanner)
}
